import { useState } from "react";
import { observer } from "mobx-react-lite";
import Icon from "@mdi/react";
import { mdiFilterOutline, mdiClose } from "@mdi/js";
import { Button } from "@heroui/react";
import { FilterPopover } from "@pro-sto/ui-v2";
import { feedbackStore } from "@/stores/FeedbackStore";
import type { FeedbackStatus } from "@/stores/FeedbackStore";
import { popoverStore } from "@/stores/PopoverStore";
import { FEEDBACK_STATUS_FILTER_OPTIONS } from "./constants";

const POPOVER_ID = "feedback-filter";

type StatusFilterValue = "all" | FeedbackStatus;

const STATUS_OPTIONS: Array<{ value: StatusFilterValue; label: string }> =
  FEEDBACK_STATUS_FILTER_OPTIONS.map((option) => ({
    value: option.value ?? "all",
    label: option.label,
  }));

const FilterPanel: React.FC = observer(() => {
  const [localStatus, setLocalStatus] = useState<StatusFilterValue>("all");

  const handleApply = () => {
    feedbackStore.setStatusFilter(
      localStatus === "all" ? null : localStatus,
    );
  };

  const handleReset = () => {
    setLocalStatus("all");
    feedbackStore.resetFilters();
    popoverStore.close(POPOVER_ID);
  };

  return (
    <div data-testid="feedback-filter-panel">
    <FilterPopover
      triggerContent={<Icon path={mdiFilterOutline} size={0.85} />}
      closeIcon={<Icon path={mdiClose} size={0.7} />}
      isActive={feedbackStore.hasActiveFilters}
      isDisabled={feedbackStore.isUiBusy}
      isOpen={popoverStore.isOpen(POPOVER_ID)}
      onOpenChange={(open) => {
        if (open) popoverStore.open(POPOVER_ID);
        else popoverStore.close(POPOVER_ID);
      }}
      onOpen={() => {
        setLocalStatus(feedbackStore.statusFilter ?? "all");
      }}
      onApply={handleApply}
      onReset={handleReset}
    >
      <div className="sc-filter-panel__group">
        <span className="sc-filter-panel__label">Статус</span>
        <div className="flex gap-1 flex-wrap">
          {STATUS_OPTIONS.map(({ value, label }) => (
            <Button
              key={value}
              size="sm"
              variant={localStatus === value ? "primary" : "tertiary"}
              onPress={() => setLocalStatus(value)}
            >
              {label}
            </Button>
          ))}
        </div>
      </div>
    </FilterPopover>
    </div>
  );
});

FilterPanel.displayName = "FilterPanel";
export default FilterPanel;
